// AlertContext.js
import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const AlertContext = createContext();

export const useAlertContext = () => useContext(AlertContext);



export const AlertProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [alertData, setAlertData] = useState({});

  const showAlert = (type, message) => {
    setAlertData({ type, message });
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
 
  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <Snackbar  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} open={isOpen} autoHideDuration={2000} onClose={handleClose}>
        <Alert variant="filled" onClose={handleClose} severity={alertData.type} sx={{ width: '100%' }}>
          {alertData.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};
